import AdminLayout from '../components/Layouts/AdminLayout'
import HeaderContainer from '../containers/Header/Header.container'
import SidebarContainer from '../containers/Sidebar/Sidebar.container'
import DashboardContainer from '../containers/Dashboard/Dashboard.container'
import DashboardReferenceColumn from '../containers/Dashboard/DashboardReferenceColumn.container'
import PensionHistoryContainer from '../containers/PensionHistory/PensionHistory.container'
import NotificationListContainer from '../containers/Notification/NotificationList.container'
import SupportHelpCard from '../containers/Support/SupportHelpCard'
import {
  PageSection,
  SectionHeader,
  SectionTitle,
  SectionDescription,
  NotificationSection,
  Column,
  NotificationBox,
  HistoryPanel,
} from './Dashboard.styles'

const Home = () => (
  <AdminLayout
    header={<HeaderContainer />}
    sidebar={<SidebarContainer />}
  >
    <PageSection>
      <DashboardContainer />

      <SectionHeader>
        <SectionTitle>Historial de pensión</SectionTitle>
        <SectionDescription>
          Cómo ha cambiado tu pensión mes a mes.
        </SectionDescription>
      </SectionHeader>
      <HistoryPanel>
        <PensionHistoryContainer />
      </HistoryPanel>

      <NotificationSection>
        <DashboardReferenceColumn />

        <Column>
          <SectionHeader>
            <SectionTitle>Notificaciones</SectionTitle>
            <SectionDescription>
              Avisos de tu cuenta y de tu pensión.
            </SectionDescription>
          </SectionHeader>
          <NotificationBox>
            <NotificationListContainer />
          </NotificationBox>
        </Column>
      </NotificationSection>

      <SupportHelpCard />
    </PageSection>
  </AdminLayout>
)

export default Home
